<div class="block-chat shadow-small">
    <div class="block-chat__title">{{lang.data['block.chat.title']}}</div>
    <div class="block-chat__description">
       {{lang.data['block.chat.description']}}
    </div>
    <div class="block-chat__button">
        <ion-button class="button-gray" shape="round" expand="full" (click)="openLiveChat()">
            {{lang.data['block.chat.chat_now']}}
        </ion-button>
    </div>
</div>
